import { Component, Input, Output, EventEmitter } from '@angular/core';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'complete-your-order',
  templateUrl: './complete-your-order.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
})
export class CompleteYourOrderComponent {
    @Input('productsInCart') productsInCart:any;
    @Input('cartDiscount') cartDiscount:number;
    @Input('totalSp') totalSp:number;
    @Input('userDrImage') userDrImage: any;
    @Output('goToCart') goToCart:EventEmitter<void> = new EventEmitter();
    @Input() cartScriptBannerHeaderExperiment!: boolean;
    @Input() isShopRevampExperimentOn: boolean = false;

  constructor(
    private readonly eventLogger: EventLoggerService,
  ) {
  }

  handleClick(): void {
    this.goToCart.emit();
    const eventType = this.productsInCart[0]?.isDoctorAdded ? 'doctor_added_single' : 'user_added_single';
    this.eventLogger.cleverTapEvent('Buy_Now_Cart_banner_HP_clicked', JSON.stringify({ type: eventType }));
  }

  get showReorderKitHeader(): boolean {
    if (!this.productsInCart || !this.productsInCart[0]) {
      return false;
    }
    return !!(this.productsInCart[0]?.isAddedByScript && this.cartScriptBannerHeaderExperiment);
  }

  get showDoctorAddedHeader(): boolean {
    if (!this.productsInCart || !this.productsInCart[0]) {
      return false;
    }
    return !!(this.productsInCart[0]?.isDoctorAdded && (!this.cartScriptBannerHeaderExperiment || !this.productsInCart[0]?.isAddedByScript));
  }

  get showCompleteOrderHeader(): boolean {
    if (!this.productsInCart || !this.productsInCart[0]) {
      return true;
    }
    return !this.productsInCart[0]?.isDoctorAdded;
  }
}
